import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { message } from 'antd';
import MicroComponents from './containers/micro-components';
import RightsModal from '@/containers/rights-modal';
import QaDrawer from '@/containers/qa-drawer';
import PicturePreview from '@/containers/picture-preview';
import OfflineOverlay from '@/components/offline-overlay';
import PictureCrop from '@/containers/picture-crop';
import QaDetailDrawer from '@/containers/qa-detail-drawer';
import VideoPlayerModal from '@/containers/video-player-modal';
import KnowledgeSliceRightDrawer from '@/containers/knowledge-slice-right-drawer';
import queryDomMethods from './utils/query-dom-methods';
import { initCompatibleModal } from './utils';
import sensorsInit from './utils/sensors';
import { IMicroAppProps } from '@/types/models/common';

function App(props: IMicroAppProps) {
    // 是否作为子应用被引入使用
    const isMicroApp = window.__POWERED_BY_QIANKUN__;
    // 微应用的类型
    const microAppType = props.microAppType || 'QaDrawer';
    // 是否作为纯展示页面
    const isDisplayPage = ['/user/rights/tips', '/qa-standard', '/markdown-test'].includes(window.location.pathname);

    useEffect(() => {
        if (isMicroApp) {
            message.config({ getContainer: queryDomMethods.queryLucaQaRoot });
            // 初始化埋点
            sensorsInit();
        } else if (!isDisplayPage) {
            // 初始化浏览器兼容弹窗
            initCompatibleModal();
            // 初始化埋点
            sensorsInit();
        }
        return () => {
            isMicroApp && message.destroy();
        };
    }, []);

    if (isDisplayPage) {
        return (
            <BrowserRouter>
                <Suspense>
                    <Routes>
                        {/* 用户权益说明页面APP也在引用 */}
                        <Route path="/user/rights/tips" Component={lazy(() => import('@/containers/user-power-tips-page'))} />
                        <Route path="/qa-standard" Component={lazy(() => import('@/containers/qa-standard-page'))} />
                        <Route path="/markdown-test" Component={lazy(() => import('@/containers/markdown-test'))} />
                    </Routes>
                </Suspense>
            </BrowserRouter>
        );
    }

    if (isMicroApp) {
        if (microAppType === 'QaDrawer') {
            return (
                <>
                    <QaDrawer {...props} />
                    <PictureCrop />
                    <RightsModal />
                    <PicturePreview />
                    <VideoPlayerModal />
                    <OfflineOverlay />
                </>
            );
        }
        // 微应用组件
        return <MicroComponents {...props} />;
    }

    return (
        <>
            <QaDrawer />
            <QaDetailDrawer />
            <KnowledgeSliceRightDrawer />
            <PictureCrop />
            <RightsModal />
            <PicturePreview />
            <VideoPlayerModal />
            <OfflineOverlay />
            <BrowserRouter>
                <Suspense>
                    <Routes>
                        <Route path="/home" Component={lazy(() => import('@/containers/home-page'))} />
                        <Route path="/my-question" Component={lazy(() => import('@/containers/my-question-page'))} />
                        <Route path="/my-collect" Component={lazy(() => import('@/containers/my-collect-page'))} />
                        <Route path="/qa-standard" Component={lazy(() => import('@/containers/qa-standard-page'))} />
                    </Routes>
                </Suspense>
            </BrowserRouter>
        </>
    );
}

export default App;
